import { render } from "./AllLoans.vue?vue&type=template&id=4ad98d36&scoped=true"
import script from "./AllLoans.vue?vue&type=script&lang=js"
export * from "./AllLoans.vue?vue&type=script&lang=js"

import "./AllLoans.vue?vue&type=style&index=0&id=4ad98d36&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad98d36"]])

export default __exports__